import "../../../../content/blog/2018-09-05-agile-integration.css";
import React from 'react';
export default {
  React
};